import React, { PropsWithChildren } from 'react';

import { useStoreContext } from 'features/store';
import { useIntl } from 'react-intl';

import { LocationEmptyState } from 'components/location-empty-state';
import LoyaltyLoader from 'pages/loyalty/loyalty-loader/loyalty-loader';

const MenuEmptyState = () => {
  const { formatMessage } = useIntl();
  return (
    <LocationEmptyState
      title={formatMessage({ id: 'emptyMenuHeading' })}
      message={formatMessage({ id: 'emptyMenuMessage' })}
    />
  );
};

const MenuEmptyStateWrapper = ({ children }: PropsWithChildren) => {
  const { noStoreSelected, isSelectingStore } = useStoreContext();

  if (isSelectingStore) {
    return <LoyaltyLoader />;
  }

  if (noStoreSelected) {
    return <MenuEmptyState />;
  }

  return children;
};

const withMenuEmptyState = (Component: React.ComponentType<React.PropsWithChildren>) => (
  props: any
) => {
  return (
    <MenuEmptyStateWrapper>
      <Component {...props} />
    </MenuEmptyStateWrapper>
  );
};

export default withMenuEmptyState;
